import { AxiosInstance } from 'axios';
import { result, Result } from 'util/result';
import { BuildAppVersionRequest } from 'data/terra/api/terra/request/BuildAppVersionRequest';
import {
  BuildAppVersionResponse,
  BuildAppVersionsResponse,
  CancelBuildAppResponse,
  DownloadBuildAppResponse,
} from 'data/terra/api/terra/response/BuildAppVersionResponse';

class BuildAppEndpoint {
  buildAppVersion = (versionId: string) =>
    `api/v1/build-app/version/${versionId}`;
  cancelBuildApp = (buildId: string) => `api/v1/build-app/cancel/${buildId}`;
  downloadBuildFile = (fileId: string) =>
    `api/v1/build-app/files/${fileId}/download`;
}

export class BuildAppApi {
  terraClient: AxiosInstance;
  endpoint = new BuildAppEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  buildAppVersion(
    versionId: string,
    request: BuildAppVersionRequest
  ): Promise<Result<BuildAppVersionResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<BuildAppVersionResponse>(
            this.endpoint.buildAppVersion(versionId),
            request
          )
        ).data
    );
  }

  getBuildHistoryByVersion(
    versionId: string
  ): Promise<Result<BuildAppVersionsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<BuildAppVersionsResponse>(
            this.endpoint.buildAppVersion(versionId)
          )
        ).data
    );
  }

  cancelBuildApp(buildId: string): Promise<Result<CancelBuildAppResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<CancelBuildAppResponse>(
            this.endpoint.cancelBuildApp(buildId)
          )
        ).data
    );
  }

  getBuildFileDownloadUrl(
    fileId: string
  ): Promise<Result<DownloadBuildAppResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<DownloadBuildAppResponse>(
            this.endpoint.downloadBuildFile(fileId)
          )
        ).data
    );
  }
}
